import Handler from "../Handler";
class DealICMVoteAckHandler extends Handler {
    // DealICMVoteA#{"playerName", "tourneyId", "status":STATUS_STRING}

    // STATUS_STRING has values

    // INVALID_MESSAGE → When vote key is missing

    // EXCEPTION_OCCURRED → Exception on server

    // NOT_SEATED → Watch player sent vote. Illegal action

    // DEAL_MAKING_TIMER_NOT_FOUND → No active deal making timer, what are you voting for?

    // OPTED_IN → Accepted the deal

    // OPTED_OUT → Rejected the deal

    // ALREADY_OPTED_IN → Already accepted deal stopping changes for now

    // ALREADY_OPTED_OUT → Already rejected deal, stopping changes for now

    // NOT_DEAL_PARTICIPANT → Not a participant of the deal, worst case shouldn’t come up


    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processICMVoteAckProtocol(receivedData);
    }
}
export default DealICMVoteAckHandler;
